import sessionReader from '../../store/readHelpers/SessionReader';
import { t } from '../i18nService';

import {
    IdVerificationStatus,
} from '../idverification/IdVerificationConstants';
import idVerificationService from '../idverification/IdVerificationService';

import apiService from '../api/ApiService';
import idVerificationActions from '../../actions/IdVerificationActions';
import storeManager from '../../store/StoreManager';

const manualIdVerificationService = {
    isManualIdVerificationNeeded() {
        return sessionReader.isManualIdVerificationEnabled();
    },

    isVerificationApproved(state) {
        return state.idVerificationStatus === IdVerificationStatus.VERIFIED;
    },

    isVerificationRejected(state) {
        return state.idVerificationStatus === IdVerificationStatus.REJECTED;
    },

    isVerificationNeedingFollowUp(state) {
        return state.idVerificationStatus === IdVerificationStatus.NEED_FOLLOW_UP;
    },

    isManualIdVerificationComplete(state) {
        return this.isVerificationApproved(state) || this.isVerificationNeedingFollowUp(state);
    },

    isManualIdVerificationRejected(state) {
        return this.isVerificationRejected(state);
    },

    isCurrent(
        idverification,
        isPreviousComponentCompleted = idVerificationService.isIdVerificationComplete(idverification),
        completed = this.isManualIdVerificationComplete(idverification),
    ) {
        return isPreviousComponentCompleted && !completed;
    },

    resolveManualIdVerificationWaitingMessage(remoteOralExam) {
        return remoteOralExam?.waitingRoom?.statusMessage?.trim()
            || t('manualIdVerification.pending');
    },

    requestManualIdVerification() {
        const assessmentRunId = sessionReader.getAssessmentRunId(true);
        apiService.requestManualIdVerification(assessmentRunId);
        storeManager.dispatch(idVerificationActions.setManualIdVerificationRequestSent(true));
    },
};

export default manualIdVerificationService;
